import mitt from 'mitt';

const emitter = mitt();

if (globalThis.window) {
  (window as any).__EMITTER__ = emitter;
}

export { emitter as default };
